<template>
  <div class="satellite">
    <div class="circle-line one" />
    <div class="circle-line two" />
  </div>
</template>
<script setup lang="ts">
defineOptions({
  name: 'VSatellite',
})
</script>
